import {STATUS} from '@/const/status/index';
import {FormType} from './editingTypes';
import { ADJUSTMENT_TYPE } from '@/const/types/adjustment';

export const InitialSchedule =  [
    {day: 0, schedule: [false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false]},
    {day: 1, schedule: [false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false]},
    {day: 2, schedule: [false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false]},
    {day: 3, schedule: [false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false]},
    {day: 4, schedule: [false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false]},
    {day: 5, schedule: [false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false]},
    {day: 6, schedule: [false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false]},
];

export const InitialFormData: FormType = {
    isLegacy: false,
    idList: undefined,
    name: '',
    targetInventory: [],
    budget: false,
    date: ['', ''],
    audience: [],
    impressionSchedule: {
        isUsed: false,
        impSchedule: [],
    },
}

export const InitialInventoryData: any = {
    status: STATUS.ACTIVE,
    landingURL: '',
    trackingURL: '',
    date: [],
    budget: 0,
    price: {type: ADJUSTMENT_TYPE.FREE, value: 0},
    impressionSchedule: { isUsed: false, impSchedule: []},
}